"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var enums_1 = require("../../../../types/enums");
var LbrReferralInput = function () {
    var _a, _b, _c, _d;
    var _e = __2.useSemantics(), trans = _e.trans, options = _e.options;
    var _f = formik_1.useFormikContext(), errors = _f.errors, values = _f.values;
    var value = values.project.behavioural_advice.lbr_referral;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.FormControl, { errors: (_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.behavioural_advice) === null || _b === void 0 ? void 0 : _b.lbr_referral, label: trans('project:slhh::labels.lbr-referral'), showOther: value === enums_1.BooleanOther.OTHER, other: react_1.default.createElement(__1.FormControl, { errors: (_d = (_c = errors.project) === null || _c === void 0 ? void 0 : _c.behavioural_advice) === null || _d === void 0 ? void 0 : _d.lbr_referral_other, label: trans('project:slhh::labels.lbr-referral-other') },
                react_1.default.createElement(__1.TextArea, { fast: true, name: "project.behavioural_advice.lbr_referral_other", maxLength: 5000 })) },
            react_1.default.createElement(__1.Select, { width: "xs", options: options.booleanOther(), name: "project.behavioural_advice.lbr_referral" }))));
};
exports.default = LbrReferralInput;
//# sourceMappingURL=LbrReferralInput.js.map